import * as React from "react";

const VideoIcon = (props) => (
  <svg
    width={33}
    height={33}
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.391 9.647a2.67 2.67 0 0 0-2.666-2.667h-16a2.67 2.67 0 0 0-2.667 2.667V22.98a2.67 2.67 0 0 0 2.667 2.667h16a2.67 2.67 0 0 0 2.666-2.667v-4.444l5.334 4.444V9.647L24.39 14.09V9.647Z"
      fill="currentColor"
    />
  </svg>
);

export default VideoIcon;
